import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Store, updateSelectedMatch } from '../../../store';

import './style.scss';

const ResultsToggle = ({ results }) => {
  const { state, dispatch } = useContext(Store);
  const handleClick = (result) => {
    updateSelectedMatch({ id: result, result: results[result] }, dispatch);
  };
  const regex = /(\d+-\w+-)(.*)(\.json)/;
  const sortedResults = [];

  const sortAlphaNum = (a, b) => a.localeCompare(b, 'en', { numeric: true });
  const sortResults = () => {
    for (const result of Object.keys(results)) {
      sortedResults.push(result);
    }
    sortedResults.sort(sortAlphaNum);
    return sortedResults;
  };
  sortResults();
  return (
    <React.Fragment>
      {sortedResults.map((result) => {
        return (
          <button
            key={result}
            type={'button'}
            className={
              state.selectedMatch && state.selectedMatch.id === result
                ? `selected-match`
                : `un-selected`
            }
            onClick={() => handleClick(result)}
          >
            {result.replace(regex, '$2') || result}
          </button>
        );
      })}
    </React.Fragment>
  );
};

ResultsToggle.propTypes = {
  results: PropTypes.object.isRequired,
};

export default ResultsToggle;
